import { render, staticRenderFns } from "./SectionNewsletter.vue?vue&type=template&id=41c5a91c&scoped=true&"
import script from "./SectionNewsletter.vue?vue&type=script&lang=js&"
export * from "./SectionNewsletter.vue?vue&type=script&lang=js&"
import style0 from "./SectionNewsletter.vue?vue&type=style&index=0&id=41c5a91c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41c5a91c",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {NewsletterForm: require('/builds/marketing/abstracta.academy-website/components/NewsletterForm.vue').default})
